// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const vulpix: PokeData = {
  "id": 37,
  "name": "vulpix",
  "height": 6,
  "weight": 99,
  "base_experience": 60,
  "types": [
    PokeType.FIRE
  ],
  "api_moves": [
    "tackle",
    "tail-whip",
    "roar",
    "disable",
    "ember",
    "flamethrower",
    "fire-spin",
    "quick-attack",
    "confuse-ray",
    "fire-blast",
    "flame-wheel",
    "spite",
    "feint-attack",
    "safeguard",
    "will-o-wisp",
    "imprison",
    "grudge",
    "extrasensory",
    "payback",
    "nasty-plot",
    "captivate",
    "flame-burst",
    "hex",
    "incinerate",
    "inferno",
    "baby-doll-eyes"
  ],
  "moves": [
    "tackle",
    "ember",
    "flamethrower",
    "fire-spin",
    "quick-attack",
    "confuse-ray",
    "flare-blitz",
    "fire-punch",
    "blaze-kick",
    "magma-storm",
    "sunny-day",
    "eruption",
    "fire-ball"
  ],
  "evolution_chain": {
    "id": 15,
    "item": null,
    "species": [
      {
        "name": "vulpix",
        "order": 39,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "ninetales",
        "order": 40,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 37,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "fire-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "ice-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 45.25,
    "speed": 65,
    "ability_power": 50
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
